export const SYSTEM_ANNOUNCEMENTS_CONTAINER_ID = 'systemAnnouncements';
